/**
 * Inline Creation Schema — Component
 *
 * Used by relation resolution when an activity references a component name
 * that does not exist yet.
 */

import { UploadSchema } from '../types';

export const v2ComponentSchema: UploadSchema = {
	entityType: 'v2Component',
	label: 'Component',
	apiEndpoint: '/v1/components',
	apiMethod: 'POST',
	payloadTransform: (formValues, projectId) => ({
		name: formValues.name,
		project: projectId,
	}),
	fields: [
		{
			name: 'name',
			label: 'Component Name',
			dataType: 'string',
			required: true,
			headerAliases: ['Component', 'Project Component'],
		},
	],
};
